import { Vector3 } from 'three';
import * as THREE from 'three/build/three.module';
import { J3CameraUtils } from './J3CameraUtils';
export class J3TagHelper extends EventTarget {

    tags = [];

    constructor(public prefix:string='t', public id:string='none', public tagImageDir:string = 'images', public tagWrapper:THREE.Object3D = null, public faceTagToCamera = false, initiallyOn:boolean = true) {
        // id:string = 'none'; //タググループのID名
        // tagImageDir  タグ画像の保存ディレクトリ
        // faceToCamear = false;   //タグをカメラに正対させるか？
        super();
        tagWrapper.name = id;
        if(initiallyOn){
            this.ShowTag();
        }else{
            this.HideTag();
        }
    }

    Update(cameraUtils:J3CameraUtils) {
        this.FaceTagToCamera(cameraUtils, true);
    }

    FaceTagToCamera(cameraUtils:J3CameraUtils, forced = false) {
        //マーカーをカメラに対向させる
        if(cameraUtils == null) return;
        for (const tag of this.tags) {
            if (this.faceTagToCamera || forced) {
                tag.rotation.setFromRotationMatrix(cameraUtils.camera.matrix);
            }
        }
    }

    DrawLine(ipos = [0, 0, 0], fpos = [0, 0, 0], linecolor = 0xffffff, linewidth=1) {
        const points = [];
        points.push(new Vector3(ipos[0], ipos[1], ipos[2]));
        points.push(new Vector3(fpos[0], fpos[1], fpos[2]));
        const material = new THREE.LineBasicMaterial({ color: linecolor, linewidth: linewidth});
        const geometry = new THREE.BufferGeometry().setFromPoints(points);
        const line = new THREE.Line(geometry, material);
        this.tagWrapper.add(line);
    }

    DrawTag(name: string, imagename: string, ipos = [0, 0, 0], fpos = [0, 0, 0], rot = [0, 0, 0], scl = [1, 1, 1], drawLine=false, linecolor = 0xffffff, linewidth=1, widthSegments = 4, heightSegments = 4) {
        if(this.tagWrapper == null) return;

        const geometry = new THREE.PlaneGeometry(1, 1, widthSegments, heightSegments);
        //環境画像のロード。画像名を受けて画像をロードし、environments配列に格納する
        const textureLoader = new THREE.TextureLoader();
        //console.log('loading...', this.tagImageDir + imagename, ipos);
        textureLoader.load(this.tagImageDir + imagename, (texture) => {
            const material = new THREE.MeshBasicMaterial({
                map: texture,
                color: linecolor,
                transparent: true,
            });
            const quad = new THREE.Mesh(geometry, material);
            quad.name = this.prefix + '_' + this.id + '_' + name;
            console.log('DrawTag', quad.name);
            quad.position.set(ipos[0], ipos[1], ipos[2]);
            const degToRad = Math.PI / 180.0;
            quad.rotation.set(rot[0] * degToRad, rot[1] * degToRad, rot[2] * degToRad);
            quad.scale.set(scl[0], scl[1], scl[2]);
            this.tagWrapper.add(quad);
            this.tags.push(quad);   //タグオブジェクトを配列に格納

            const iposmod = [ipos[0], ipos[1] - scl[1] / 2, ipos[2]];
            if(drawLine) this.DrawLine(iposmod, fpos, linecolor, linewidth);
        });
    }

    ShowTag(){
        if(this.tagWrapper){
            this.tagWrapper.visible = true;
        }
    }

    HideTag(){
        if(this.tagWrapper){
            this.tagWrapper.visible = false;
        }
    }

}